import { IMorphOptions } from "../../Model/RingModel";
import { RenderEngine } from "./core/RenderEngine";
import * as THREE from "three";

/**
 * Handles updates of logo on the 3D-model.
 */

export class LogoController {
  public logoActive:boolean;
  private _renderEngine:RenderEngine;
  private _logoImage:HTMLImageElement = new Image();
  private _logoNormalImage:HTMLImageElement = new Image();
  private _maxLogoHeight:number; //ringWidth beyond which logo stops scaling up

  constructor(renderEngine:RenderEngine, assetURI:string, logoStyle:'ifr'|'luxe') {
    this.logoActive = true;
    this._renderEngine = renderEngine;
    this._logoImage.crossOrigin = "anonymous";
    if (logoStyle == 'ifr') this._logoImage.src = `${assetURI}/images/logo/Logo_IFR.png`;
    if (logoStyle == 'luxe') this._logoImage.src = `${assetURI}/images/logo/Logo_Luxe.png`;
    this._logoNormalImage.crossOrigin = "anonymous";
    if (logoStyle == 'ifr') this._logoNormalImage.src = `${assetURI}/images/logo/Logo_IFR_Normal.png`;
    if (logoStyle == 'luxe') this._logoNormalImage.src = `${assetURI}/images/logo/Logo_Luxe_Normal.png`;
    this._maxLogoHeight = 5;
  };

  public updateLogo = async (ringWidth:number, morphOptions:IMorphOptions) => {
    const { 
      _renderEngine: renderEngine, 
      _logoImage: logoImage, 
      _logoNormalImage: logoNormalImage,
      _maxLogoHeight: maxLogoHeight
    } = this;

    const logoImageAspectRation = logoImage.width / logoImage.height;
    const canvasAspectRatio = ringWidth/ morphOptions.width[morphOptions.width.length-1];
    const logoSizeFactor = (ringWidth > maxLogoHeight) ? (maxLogoHeight/ ringWidth) : 1;

    const meshes = await renderEngine.engine.services.render.getAllMeshesOfCurrentScene()

    //Enable polygonOffset for engraving material(s) to prevent Z fighting
    const logoGroupings = renderEngine.configurator.config.groupings.filter(g => g.name.includes("Logo"));

    logoGroupings.forEach((logoGrouping)=> {
      logoGrouping.object_names.forEach((objName) => {
        try {
          const logoMesh = meshes.find(mesh => mesh.name === objName);
          const logoMaterial = (logoMesh.material as THREE.MeshPhysicalMaterial);

          const logoCanvas = document.createElement('canvas');
          const logoNormalCanvas = document.createElement('canvas');
          logoCanvas.width = 1000;
          logoNormalCanvas.width = logoCanvas.width;
          logoCanvas.height = logoCanvas.width * canvasAspectRatio;
          logoNormalCanvas.height = logoCanvas.height;

          const imgWidth = (logoImageAspectRation > 1) ? logoCanvas.width : logoCanvas.height * logoSizeFactor;
          const imgHeight = (logoImageAspectRation > 1) ? logoCanvas.width / logoImageAspectRation : logoCanvas.height * logoSizeFactor;
          const dx = logoCanvas.width/ 2 - imgWidth/ 2;
          const dy = logoCanvas.height/ 2 - imgHeight/ 2;

          const logoCanvasContext = logoCanvas.getContext('2d');

          if (this.logoActive) logoCanvasContext.drawImage(logoImage, 0, 0, logoImage.width, logoImage.height, dx, dy, imgWidth, imgHeight);
          logoMaterial.map = new THREE.Texture(logoCanvas);
          logoMaterial.map.flipY = false;
          logoMaterial.map.needsUpdate = true;

          const logoNormalCanvasContext = logoNormalCanvas.getContext('2d');
          if (this.logoActive) logoNormalCanvasContext.drawImage(logoNormalImage, 0, 0, logoNormalImage.width, logoNormalImage.height, dx, dy, imgWidth, imgHeight);
          logoMaterial.normalMap = new THREE.Texture(logoNormalCanvas);
          logoMaterial.normalMap.flipY = false;
          logoMaterial.normalMap.needsUpdate = true;

          logoMaterial.needsUpdate = true;

        } catch(e) {
          console.error('Mesh/ Material not found for logoGrouping!', logoGrouping, e);
        };
      });
    })
  };
};